<template>
	<component :is="icon" :size="size" :stroke-width="strokeWidth" aria-hidden="true" focusable="false" />
</template>

<script setup>
import { computed } from 'vue';
import {
	Bell,
	Building2,
	Check,
	ChevronDown,
	ChevronUp,
	CircleHelp,
	ClipboardList,
	CreditCard,
	Eye,
	EyeOff,
	FileText,
	Info,
	List,
	LoaderCircle,
	LockKeyhole,
	LogOut,
	Mail,
	MapPin,
	Menu,
	PanelsTopLeft,
	Pencil,
	Phone,
	Plus,
	TriangleAlert,
	Trash2,
	UserRound,
	Users,
	X,
} from '@lucide/vue';

const props = defineProps({
	name: {
		type: String,
		required: true,
	},
	size: {
		type: [Number, String],
		default: 18,
	},
	strokeWidth: {
		type: [Number, String],
		default: 2,
	},
});

const icons = {
	alert: TriangleAlert,
	bell: Bell,
	building: Building2,
	check: Check,
	chevronDown: ChevronDown,
	chevronUp: ChevronUp,
	declaration: ClipboardList,
	email: Mail,
	eye: Eye,
	eyeOff: EyeOff,
	faq: CircleHelp,
	info: Info,
	list: List,
	location: MapPin,
	lock: LockKeyhole,
	logout: LogOut,
	menu: Menu,
	phone: Phone,
	plus: Plus,
	profile: UserRound,
	records: PanelsTopLeft,
	report: FileText,
	spinner: LoaderCircle,
	subscription: CreditCard,
	trash: Trash2,
	edit: Pencil,
	users: Users,
	x: X,
};

const icon = computed(() => icons[props.name] || CircleHelp);
</script>
